import React, { useEffect, useState} from "react";
import {I18nProvider, Button, Calendar, CalendarCell, CalendarGrid, CalendarGridBody, CalendarGridHeader, CalendarHeaderCell, DateInput, DatePicker, DateSegment, Dialog, Group, Heading, Label, Popover} from 'react-aria-components';
import type {ButtonProps, PopoverProps} from 'react-aria-components';
import ChevronUpDownIcon from '@spectrum-icons/workflow/ChevronUpDown';
import ChevronLeftIcon from '@spectrum-icons/workflow/ChevronLeft';
import ChevronRightIcon from '@spectrum-icons/workflow/ChevronRight';
import {parseDate, CalendarDate, parseAbsoluteToLocal} from '@internationalized/date';
import {today, getLocalTimeZone, parseDateTime} from '@internationalized/date';
import moment from 'moment'
import { Switch, Field } from '@headlessui/react'
export function PPCDatepicker({...props}) {
    const [activeStartDate, setActiveStartDate] = useState(true);
const startDateActiveHandler=((isOn) => {
    setActiveStartDate(isOn);
});
    
const changeDate=((defVal) => {
    if(!defVal) {
        let momentObj = moment();
        if(props?.onEmpty) {
            momentObj.add(1, "hour");
        }
        defVal = parseDateTime(momentObj.format("YYYY-MM-DDTHH:mm:ss"));
        return defVal;
    } else 
    if((typeof defVal) == 'string') {
        defVal = parseDate(defVal);
    } else if((typeof defVal) == 'number') {
        defVal = parseDateTime(moment(defVal).format('YYYY-MM-DDTHH:mm:ss'));
    } else  {
        defVal = parseDate(moment(defVal.toString()).format('YYYY-MM-DD'));
    }
    return defVal;
    });
    
    
    let defVal = changeDate(props.defaultValue);
    let [value, setValue] = React.useState(defVal);

        
    const onChangeEventHandler=((selectedDate) => {
        if(props?.onChangeHandler) {
                selectedDate.month  -= 1;
            props.onChangeHandler(props?.name, moment(selectedDate).valueOf());
            selectedDate.month  += 1;
        }
        setValue(selectedDate);        
    });

  return (
      <I18nProvider locale="nl-NL">
    <div className={props?.className} key={props?.label+"asjdahsdj "+(activeStartDate)? "_on" : "_off"}>

        <div className="flex justify-between gap-2">
        <Label className="text-black cursor-default text-sm font-medium leading-6 text-gray-900">{props?.label}</Label>
    
        </div>
    <div  key={props?.label+"key_"+(activeStartDate)? "1" : "0"} className={(activeStartDate == true) ? "" : "hidden"} > 
      <DatePicker className={"group flex flex-col gap-1 w-full "} defaultValue={value} shouldForceLeadingZeros={true} onChange={onChangeEventHandler}
  hourcycle={24}>
        <Group className="flex border pl-1 component block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6">
          <DateInput className="flex flex-1 py-1" >
            {(segment) => {
                return(
                <>
              <DateSegment  
                segment={segment}
                className="px-0.5 tabular-nums outline-none rounded-sm focus:bg-violet-700 focus:text-white caret-transparent placeholder-shown:italic"
              />
              </>
            )}}
          </DateInput>
          <Button className="outline-none px-1 flex items-center text-gray-700 transition border-0 border-solid border-l border-l-purple-200 bg-transparent rounded-r-lg pressed:bg-purple-100 focus-visible:ring-2 ring-black">
            <ChevronUpDownIcon width={"16px"}/>
          </Button>
        </Group>
        <MyPopover>
          <Dialog className="p-2 text-gray-600">
            <Calendar>
              <header className="flex items-center pb-4 px-1 font-serif w-full">
                <Heading className="flex-1 font-semibold text-2xl ml-2" />
                <RoundButton slot="previous">
                  <ChevronLeftIcon />
                </RoundButton>
                <RoundButton slot="next">
                  <ChevronRightIcon />
                </RoundButton>
              </header>
              <CalendarGrid className="border-spacing-1 border-separate">
                <CalendarGridHeader>
                  {(day) => (
                    <CalendarHeaderCell className="text-xs text-gray-500 font-semibold">
                      {day}
                    </CalendarHeaderCell>
                  )}
                </CalendarGridHeader>
                <CalendarGridBody>
                  {(date) => (
                    <CalendarCell
                      date={date}
                      className="w-9 h-9 outline-none cursor-default rounded-full flex items-center justify-center outside-month:text-gray-300 hover:bg-gray-100 pressed:bg-gray-200 selected:bg-violet-700 selected:text-white focus-visible:ring ring-violet-600/70 ring-offset-2"
                    />
                  )}
                </CalendarGridBody>
              </CalendarGrid>
            </Calendar>
          </Dialog>
        </MyPopover>
      </DatePicker>
      </div>
    </div>
    </I18nProvider>
  );
}

function RoundButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      className="w-9 h-9 outline-none cursor-default bg-transparent text-gray-600 border-0 rounded-full flex items-center justify-center hover:bg-gray-100 pressed:bg-gray-200 focus-visible:ring ring-violet-600/70 ring-offset-2"
    />
  );
}

function MyPopover(props: PopoverProps) {
  return (
    <Popover
      {...props}
      className={({ isEntering, isExiting }) => `
        overflow-auto rounded-lg drop-shadow-lg ring-1 ring-black/10 bg-white
        ${
        isEntering
          ? 'animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 ease-out duration-200'
          : ''
      }
        ${
        isExiting
          ? 'animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 ease-in duration-150'
          : ''
      }
      `}
    />
  );
}